type MatchesInfo = Record<string, {
    current: {
        name: string,
    },
    prev: {
        path: string,
        name: string,
    }[]
}>

export const matchesInfo: MatchesInfo = {
    delivery: {
        current: {
            name: 'Доставка',
        },
        prev: [],
    },
    catering: {
        current: {
            name: 'Кейтеринг',
        },
        prev: [],
    },
    catering_formats: {
        current: {
            name: 'Форматы',
        },
        prev: [
            {
                path: '/catering',
                name: 'Кейтеринг',
            },
        ],
    },
    'catering_event-format': {
        current: {
            name: 'Формат мероприятия',
        },
        prev: [
            {
                path: '/catering',
                name: 'Кейтеринг',
            },
        ],
    },
    catering_event: {
        current: {
            name: 'Мероприятие',
        },
        prev: [
            {
                path: '/catering',
                name: 'Кейтеринг',
            },
        ],
    },
    'culinary-studio': {
        current: {
            name: 'Кулинарная студия',
        },
        prev: [],
    },
    'portfolio-events': {
        current: {
            name: 'Портфолио',
        },
        prev: [],
    },
    'portfolio-event': {
        current: {
            name: 'Кейс',
        },
        prev: [
            {
                path: '/portfolio-events',
                name: 'Портфолио',
            },
        ],
    },
    places: {
        current: {
            name: 'Партнёрские площадки',
        },
        prev: [],
    },
    place: {
        current: {
            name: 'Партнёрская площадка',
        },
        prev: [
            {
                path: '/places',
                name: 'Партнёрские площадки',
            },
        ],
    },
    'outdoor-bars': {
        current: {
            name: 'Выездные бары',
        },
        prev: [],
    },
    'outdoor-bar-article': {
        current: {
            name: 'Позиция магазина',
        },
        prev: [
            {
                path: '/outdoor-bars',
                name: 'Выездные бары',
            },
        ],
    },
    'sweet-shop': {
        current: {
            name: 'Кондитерская',
        },
        prev: [],
    },
    'sweet-shop-article': {
        current: {
            name: 'Позиция магазина',
        },
        prev: [
            {
                path: '/sweet-shop',
                name: 'Кондитерская',
            },
        ],
    },
    'sweet-shop-articles': {
        current: {
            name: 'Позиции магазина',
        },
        prev: [
            {
                path: '/sweet-shop',
                name: 'Кондитерская',
            },
        ],
    },
    'culinary-studio-article': {
        current: {
            name: 'Позиция магазина',
        },
        prev: [
            {
                path: '/culinary-studio',
                name: 'Кулинарная студия',
            },
        ],
    },
    'delivery-article': {
        current: {
            name: 'Позиция магазина',
        },
        prev: [
            {
                path: '/delivery',
                name: 'Доставка',
            },
        ],
    },
    cart: {
        current: {
            name: 'Корзина',
        },
        prev: [],
    },
};
